import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import {
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { BaseFormComponentComponent } from '../base-form-component/base-form-component.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'ui-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
  ],
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent<T> extends BaseFormComponentComponent<T> {
  @Input()
  type = 'text';

  @Input()
  invisible = false;
  private _errorMessage = '';

  @Input()
  get errorMessage(): string {
    return this._errorMessage;
  }

  set errorMessage(value: string) {
    this._errorMessage = value;
    if (this.control) {
      if (value == '') {
        this.control.setErrors(null);
      } else {
        this.control.setErrors({ customError: true });
      }
    }
  }
}
